/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

nve-chat-message:has([slot='prefix'])::part(_message),
nve-chat-message:has([slot='suffix'])::part(_message) {
  margin-block-start: var(--top-offset);
}
